"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LineItem_1 = require("./LineItem");
exports.default = LineItem_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/LineItem/index.js
// module id = 421
// module chunks = 8